module.exports = __webpack_public_path__ + "img/logo.0e3aedb6.png";